/**
 * DEV/MOCK-ONLY: a synthetic bearer token used in MSW mock mode so the app
 * presents an authenticated *admin* identity (the admin config UI is gated on
 * the Zitadel `ADMINISTRATOR` project role — see `auth/claims.ts`).
 *
 * The frontend never verifies the signature; it only base64-decodes the payload
 * (`decodeJwt`), so an unsigned token with the right role claim is sufficient to
 * exercise the full UI against MSW. This module is only imported on the MSW
 * bootstrap path in `main.tsx`.
 */

function base64url(value: unknown): string {
  // Claims here are pure ASCII, so btoa is safe.
  return btoa(JSON.stringify(value))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

const header = { alg: 'none', typ: 'JWT' };

const payload = {
  sub: '33333333-3333-3333-3333-333333333333',
  name: 'John Smith',
  email: 'john.smith@company.com',
  // Zitadel emits granted project roles as keys under this claim; the presence
  // of ADMINISTRATOR is what `isAdminToken` looks for.
  'urn:zitadel:iam:org:project:roles': { ADMINISTRATOR: {} },
};

export const MOCK_ADMIN_TOKEN = `${base64url(header)}.${base64url(payload)}.mock-signature`;
